import {getNextCounter} from '~/src/utilities/helpers/counters';

import {ContentType} from '~/src/utilities/constants/types';
import {AdFormat} from '~/src/utilities/constants/formats';

import cssConfig from '~/src/css/global.module.scss';

const getAdUnitName = (name, position) => {
    return position ? `${name}-pos${position}` : name;
};

const transformAd = (element, adUnitName) => {
    if (element.type === 'ad') {
        element.adUnitName = getAdUnitName(adUnitName, getNextCounter(adUnitName));
    }

    return element;
};

const showAd = (showOn) => {
    if (!showOn.desktop && !showOn.mobileWeb) {
        return false;
    }
    if (process.browser) {
        const width = window.innerWidth;
        const breakpointDesktop = parseInt(cssConfig.breakpointDesktop);

        if ((width < breakpointDesktop && !showOn.mobileWeb) || (width >= breakpointDesktop && !showOn.desktop)) {
            return false;
        }
    } else {
        return false;
    }
    return true;
};

const showContentAd = (contentType, adFormat) => {
    switch (contentType) {
        case ContentType.ARTICLE:
        case ContentType.LIFESTYLE:
            return [
                AdFormat.INSIDE_FULL_POS,
                AdFormat.INSIDE_FULL_TOP,
                AdFormat.INSIDE_FULL_BRANDDAY,
                AdFormat.INSIDE_QUARTER_POS,
                AdFormat.CONTENT_END,
                AdFormat.OUTSIDE_RIGHT
            ].includes(adFormat);
        case ContentType.TICKER:
        case ContentType.EMBED:
            return [
                AdFormat.INSIDE_FULL_POS,
                AdFormat.INSIDE_FULL_TOP,
                AdFormat.INSIDE_FULL_BRANDDAY,
                AdFormat.INSIDE_QUARTER_POS,
                AdFormat.OUTSIDE_RIGHT
            ].includes(adFormat);
        case ContentType.VIDEO:
            return [AdFormat.INSIDE_FULL_BRANDDAY, AdFormat.OUTSIDE_RIGHT, AdFormat.INSIDE_FULL_POS, AdFormat.CONTENT_END].includes(adFormat);
        default:
            return false;
    }
};

export {getAdUnitName, transformAd, showAd, showContentAd};
